module.exports = __webpack_public_path__ + "static/media/1916832_1258102579401_6580340_n.010711a6.jpg";